import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-neutral-200 pt-16 pb-8 text-neutral-600">
      <div className="max-w-[1400px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
        {/* About / Brand */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <Link to="/" className="inline-block">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=240,quality=85,format=auto/assets/a3d6ce76-96f3-4371-8c41-b2ca08e435bb/john-calmar-logo.png"
                alt="John Calmar – Clairvoyance & Hypnose i Aarhus"
                className="h-10 w-auto object-contain"
              />
            </Link>
          </div>
          <div className="flex items-center gap-4 pt-2">
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-400 hover:text-neutral-950 transition-colors duration-150"
              aria-label="Facebook"
            >
              <Facebook className="w-5 h-5" />
            </a>
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-neutral-400 hover:text-neutral-950 transition-colors duration-150"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="space-y-4">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-neutral-950">Ydelser & Kurser</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/clairvoyance-online" className="hover:text-neutral-950 transition-colors duration-150">
                Clairvoyance
              </Link>
            </li>
            <li>
              <Link to="/hypnose" className="hover:text-neutral-950 transition-colors duration-150">
                Hypnose
              </Link>
            </li>
            <li>
              <Link to="/shamanisme" className="hover:text-neutral-950 transition-colors duration-150">
                Shamanisme
              </Link>
            </li>
            <li>
              <Link to="/auratydning" className="hover:text-neutral-950 transition-colors duration-150">
                Auratydning
              </Link>
            </li>
            <li>
              <Link to="/kurser-og-uddannelse" className="hover:text-neutral-950 transition-colors duration-150">
                Kurser & Uddannelse
              </Link>
            </li>
            <li>
              <Link to="/calmars-univers" className="hover:text-neutral-950 transition-colors duration-150">
                Calmars Univers
              </Link>
            </li>
            <li>
              <Link to="/butik" className="hover:text-neutral-950 transition-colors duration-150">
                Butik
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="space-y-4">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-neutral-950">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-neutral-950 shrink-0 mt-0.5" />
              <span>Lykkesholms Allé 102, 1.th, 8260 Viby J</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-neutral-950 shrink-0" />
              <a href="tel:40938593" className="hover:text-neutral-950 transition-colors whitespace-nowrap">
                +45 40 93 85 93
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-neutral-950 shrink-0" />
              <a href="mailto:info@johncalmar.dk" className="hover:text-neutral-950 transition-colors whitespace-nowrap">
                info@johncalmar.dk
              </a>
            </li>
          </ul>
        </div>

        {/* Legal Links */}
        <div className="space-y-4">
          <h4 className="text-xs font-semibold uppercase tracking-widest text-neutral-950">Information</h4>
          <ul className="space-y-2.5 text-sm">
            <li>
              <Link to="/om-john" className="hover:text-neutral-950 transition-colors duration-150">
                Min historie
              </Link>
            </li>
            <li>
              <Link to="/referencer" className="hover:text-neutral-950 transition-colors duration-150">
                Klient-referencer
              </Link>
            </li>
            <li>
              <Link to="/moed-mig" className="hover:text-neutral-950 transition-colors duration-150">
                Mød mig på messer
              </Link>
            </li>
            <li>
              <Link to="/handelsbetingelser" className="hover:text-neutral-950 transition-colors duration-150">
                Handelsbetingelser
              </Link>
            </li>
            <li>
              <Link to="/cookie-og-privatlivsbetingelser" className="hover:text-neutral-950 transition-colors duration-150">
                Privatlivspolitik
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-[1400px] mx-auto px-6 mt-16 pt-8 border-t border-neutral-200 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-neutral-500">
        <p>© {currentYear} John Calmar. Alle rettigheder forbeholdes. CVR nr.: 33340095</p>
        <p className="flex items-center gap-1.5">
          <span>Udviklet med omhu af</span>
          <span className="text-neutral-800 font-medium tracking-wider uppercase">Auxo</span>
        </p>
      </div>
    </footer>
  );
}
